import {
  Assignment,
  Business,
  CheckCircle,
  Description,
  EventAvailable,
  EventBusy,
  Schedule,
} from '@mui/icons-material';
import { Grid } from '@mui/material';
import InfoCard from 'lib/common/GeneralComponents/TenderModal/Components/InfoCard';
import SectionCard from 'lib/common/GeneralComponents/TenderModal/Components/SectionCard';
import { formatDate } from 'lib/functions/utils';
import { Portfolio } from 'lib/types/models';
import React from 'react';

const formatDateString = (value?: string | null): string => {
  if (!value) return '-';
  try {
    return formatDate(new Date(value), 'dd-mm-yyyy');
  } catch {
    return '-';
  }
};

const GeneralInfo: React.FC<{ portfolio: Portfolio }> = ({ portfolio }) => (
  <SectionCard title="Información General">
    <Grid container spacing={1.5}>
      <InfoCard
        icon={<CheckCircle />}
        label="Estado"
        valueText={portfolio.status}
        color={'primary.main'}
      />
      <InfoCard
        icon={<Assignment />}
        label="Plantilla"
        valueText={portfolio.templateId ? 'Sí' : 'No'}
        color={'primary.main'}
      />
      <InfoCard
        icon={<Business />}
        label="Cliente"
        valueText={portfolio.businessIdentifier}
        color={'info.main'}
      />
      <InfoCard
        icon={<Description />}
        label="Tipo de Solicitud"
        valueText={portfolio.requestType ?? 'No disponible'}
        color={'success.main'}
      />
      <InfoCard
        icon={<EventAvailable />}
        label="Válido hasta"
        valueText={formatDateString(portfolio.validUntil)}
        color={'warning.main'}
      />
      <InfoCard
        icon={<EventBusy />}
        label="Invalidado el"
        valueText={formatDateString(portfolio.invalidatedAt)}
        color={'error.main'}
      />
      <InfoCard
        icon={<Schedule />}
        label="Creado"
        valueText={formatDateString(portfolio.createdAt)}
        color={'primary.main'}
      />
    </Grid>
  </SectionCard>
);

export default GeneralInfo;
